// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SearchForCipHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import CipNumberDetailDTO from '../models/CipNumberDetailDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    searchString: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            searchString: "",
        },
        initValues);
    },
    searchString: 'searchString',
}

interface Result extends ResultDTO {
    cips: CipNumberDetailDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            cips: [],
        },
        initValues);
    },
    cips: 'cips',
}

export { Request, Result };